import { useSearchParams } from "react-router-dom";
import { usePageTitle } from "../../../hooks/usePageTitle";
import GlossaryContent from "./GlossaryContent";

/**
 * Standalone glossary route. Kept for deep links and for reading at length; the
 * everyday entry point is the button in the query builder, which opens the same
 * content in a dialog. `?guide=<id>` opens a guide and scrolls to it (the action
 * chart's aPPP / ePPP tooltips link here).
 */
export default function Glossary() {
  usePageTitle("Glossary");
  const [params] = useSearchParams();
  return <GlossaryContent initialGuide={params.get("guide")} />;
}
